/* eslint-disable no-empty-function */
function pushConversionChuteEvent () {
	
}

module.exports = pushConversionChuteEvent;
